import { useMutation, useQueryClient } from '@tanstack/react-query'

import { FinanceService } from '../lib/finance.service'
import { InvoicePaymentMethods, PaymentDetail } from '../lib/finance.types'
import { INVOICE_PAYMENT_METHODS } from './useInvoicePaymentMethods'
import { FINANCE_PAYMENT_DETAIL } from './usePaymentDetail'

export const useCardDelete = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (cardId: string) => {
      return FinanceService.deleteCard(cardId)
    },
    onSuccess: (_data, cardId) => {
      queryClient.setQueriesData<PaymentDetail>(
        { queryKey: [FINANCE_PAYMENT_DETAIL] },
        previousData => {
          if (!previousData?.cards) {
            return previousData
          }
          return {
            ...previousData,
            cards: previousData.cards.filter(card => card.id !== cardId)
          }
        }
      )

      queryClient.setQueriesData<InvoicePaymentMethods>(
        { queryKey: [INVOICE_PAYMENT_METHODS] },
        previousData => {
          if (!previousData?.acquiring?.cards) {
            return previousData
          }
          return {
            ...previousData,
            acquiring: {
              ...previousData.acquiring,
              cards: previousData.acquiring.cards.filter(
                card => card.id !== cardId
              )
            }
          }
        }
      )
    }
  })
}
